<template>
  <layout :show-profile="true">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8 pt-12">
      <div class="flex flex-col">
        <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8 ">
          <fieldset class="mt-0 max-w-sm mx-auto select-none">
            <div class="space-y-8">
              <div class="md:flex md:items-center md:justify-between">
                <div class="flex-1 min-w-0">
                  <h2 class="text-2xl font-light leading-7 text-gray-900 sm:text-3xl sm:leading-9 sm:truncate">
                    Copy Quick Check
                  </h2>
                </div>
                <div class="mt-4 flex md:mt-0 md:ml-4">
                  <Link :href="route('copy-quick-check.index')"
                    class="inline-flex items-center rounded-md border border-gray-300 bg-white px-2 py-1 text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-50">
                  Neue Analyse
                  </Link>
                </div>
              </div>

              <div class="mt-0 mx-auto select-text">
                <div>
                  <div class="rounded-lg border border-gray-200 bg-white p-4 shadow-sm mb-2">
                    <div class="text-sm font-semibold text-gray-900">Analysierter Text ({{ request.input_text.length }}
                      Zeichen)</div>
                    <div class="mt-2 whitespace-pre-line text-sm text-gray-700 leading-6">
                      {{ displayedInputText }}
                      <button v-if="isInputTextTruncated" type="button"
                        class="text-sm text-gray-600 hover:text-gray-900 underline" @click="toggleInputText">
                        {{ inputTextExpanded ? 'weniger' : 'mehr' }}
                      </button>
                    </div>
                  </div>

                  <div class="rounded-lg border border-gray-200 bg-gray-50 p-4 text-sm mb-2 text-gray-700 shadow-sm">
                    <div class="flex items-center justify-between">
                      <div class="text-sm font-semibold text-gray-900">Status</div>

                      <div class="flex items-center gap-4">
                        <span :class="statusBadgeClass"
                          class="inline-flex items-center gap-2 rounded-full px-2.5 py-0.5 text-xs font-medium">
                          <span v-if="jobStatus === 'running' || jobStatus === 'queued'"
                            class="inline-block h-3 w-3 animate-spin rounded-full border-2 border-gray-300 border-t-gray-600"></span>
                          {{ statusLabel }}


                        </span>
                      </div>




                    </div>

                    <div v-if="false">
                      <div v-if="jobTotalTokens !== null || jobCost !== null" class="mt-2 text-xs text-gray-600">
                        <div v-if="jobCost !== null">Kosten: {{ formattedCost }}</div>
                        <div v-if="jobTotalTokens !== null">
                          Tokens: {{ jobTotalTokens }}
                          <span v-if="jobPromptTokens !== null && jobCompletionTokens !== null">
                            (Prompt {{ jobPromptTokens }}, Completion {{ jobCompletionTokens }})
                          </span>
                        </div>
                      </div>
                    </div>



                    <div v-if="jobStatus === 'running' || jobStatus === 'queued'" class="mt-2">

                    </div>
                    <div v-if="jobStatus === 'failed'" class="mt-2 text-red-600">
                      <span v-if="false">Fehler: {{ jobError || 'Unbekannter Fehler' }}</span>

                      <button type="button"
                        class="mt-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-1 py-1  text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-50 disabled:opacity-50"
                        :disabled="retrying" @click="retryAnalysis">
                        {{ retrying ? 'Wird gestartet...' : 'Erneut versuchen' }}
                      </button>
                    </div>
                  </div>

                  <div v-if="jobStatus === 'completed'" class="rounded-lg border border-gray-200 bg-white p-4 text-sm mb-6 text-gray-700 shadow-sm">
                    <div class="flex items-center justify-between gap-4">
                      <div class="text-sm font-semibold text-gray-900">Titel</div>

                      <div class="flex-1 text-right flex items-center justify-end gap-3">
                        <button v-if="!titleEditing" type="button"
                          class="cursor-pointer"
                          :class="titleButtonClass"
                          @click="startEditTitle">
                          {{ displayTitle }}
                        </button>

                        <input v-else type="text"
                          v-model="titleValue"
                          maxlength="50"
                          class="w-full max-w-xs rounded-md border border-gray-300 px-2 py-0.5 text-sm text-gray-900 leading-5 focus:border-markencode-blue focus:ring-markencode-blue"
                          placeholder="Titel eingeben"
                          @keydown.enter="saveTitle"
                          @keydown.esc="cancelEditTitle"
                          @blur="cancelEditTitle" />

                        <!-- PDF Export: start -->
                        <span v-if="titleSaving"
                          class="inline-block h-4 w-4 animate-spin rounded-full border-2 border-gray-300 border-t-gray-600"></span>
                        <svg v-else
                          xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"
                          class="w-5 h-5 shrink-0"
                          :class="pdfIconClass"
                          @click="downloadPdf">
                          <rect width="256" height="256" fill="none" />
                          <polyline points="216 152 184 152 184 208" fill="none" stroke="currentColor"
                            stroke-linecap="round" stroke-linejoin="round" stroke-width="16" />
                          <line x1="208" y1="184" x2="184" y2="184" fill="none" stroke="currentColor"
                            stroke-linecap="round" stroke-linejoin="round" stroke-width="16" />
                          <path d="M48,192H64a20,20,0,0,0,0-40H48v56" fill="none" stroke="currentColor"
                            stroke-linecap="round" stroke-linejoin="round" stroke-width="16" />
                          <path d="M112,152v56h16a28,28,0,0,0,0-56Z" fill="none" stroke="currentColor"
                            stroke-linecap="round" stroke-linejoin="round" stroke-width="16" />
                          <path d="M48,112V40a8,8,0,0,1,8-8h96l56,56v24" fill="none" stroke="currentColor"
                            stroke-linecap="round" stroke-linejoin="round" stroke-width="16" />
                          <polyline points="152 32 152 88 208 88" fill="none" stroke="currentColor"
                            stroke-linecap="round" stroke-linejoin="round" stroke-width="16" />
                        </svg>
                        <!-- PDF Export: end -->
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="jobStatus === 'completed'" class="lg:col-span-7 space-y-2">


                  <!-- Matrix: start -->
                  <div v-if="matrixImageUrl" class="rounded-lg pb-2">
                    <div class="relative w-full" style="aspect-ratio: 1 / 1;">
                      <div v-if="matrixImageLoading" class="absolute inset-0 flex items-center justify-center">
                        <span
                          class="inline-block h-6 w-6 animate-spin rounded-full border-2 border-gray-300 border-t-gray-600"></span>
                      </div>
                      <img :src="matrixImageUrl" alt="Matrix" class="absolute inset-0 h-full w-full object-contain"
                        @load="matrixImageLoading = false" @error="matrixImageLoading = false" />
                    </div>
                  </div>
                  <!-- Matric: end -->


                  <!-- Adjectives: start -->
                  <div class="grid grid-cols-1 gap-6 md:grid-cols-2">

                    <!-- Characterization adjectives: start -->
                    <div class="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
                      <div class="text-sm font-semibold text-gray-900">Adjektive zur Charakterisierung</div>
                      <ul class="mt-3 space-y-1 text-sm text-gray-700">
                        <li v-for="(item, index) in characterizationAdjectives" :key="`char-${index}`">
                          » {{ item.label }}
                        </li>
                        <li v-if="!characterizationAdjectives.length" class="text-gray-400">—</li>
                      </ul>
                    </div>
                    <!-- Characterization adjectives: end -->

                    <!-- Language style adjectives: start -->
                    <div class="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
                      <div class="text-sm font-semibold text-gray-900">Adjektive zum Sprachstil</div>
                      <ul class="mt-3 space-y-1 text-sm text-gray-700">
                        <li v-for="(item, index) in styleAdjectives" :key="`style-${index}`">
                          » {{ item.label }}
                        </li>
                        <li v-if="!styleAdjectives.length" class="text-gray-400">—</li>
                      </ul>
                    </div>
                    <!-- Language style adjectives: end -->
                  </div>
                  <!-- Adjectives: end -->

                  <!-- Central Theme: start -->
                  <div class="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
                    <div class="text-sm font-semibold text-gray-900">Zentrales Thema</div>
                    <div class="mt-2 text-sm text-gray-700">
                      <div class="font-medium text-gray-900">{{ centralTheme.label || '—' }}</div>
                      <div class="mt-2 leading-6">{{ centralTheme.text || '—' }}</div>
                    </div>
                  </div>
                  <!-- Central Theme: end -->

                  <!-- Uniqueness: start -->
                  <div class="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
                    <div class="text-sm font-semibold text-gray-900">Besonderheit</div>
                    <div class="mt-2 text-sm text-gray-700 leading-6">
                      {{ uniquenessText || '—' }}
                    </div>
                  </div>
                  <!-- Uniqueness: end -->


                  <!-- Language style: start -->
                  <div class="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
                    <div class="text-sm font-semibold text-gray-900">Sprachstil</div>
                    <div class="mt-2 text-sm text-gray-700">
                      <div class="font-medium text-gray-900">{{ languageStyle.label || '—' }}</div>
                      <div class="mt-2 leading-6">{{ languageStyle.text || '—' }}</div>
                    </div>
                  </div>
                  <!-- Language style: end -->



                  <!-- Identifiable patterns: start -->
                  <div class="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
                    <div class="text-sm font-semibold text-gray-900">10 Hinweise identifizierter Muster, Eigenarten und
                      Mechanismen</div>
                    <ol class="mt-4 space-y-4 text-sm text-gray-700">
                      <li v-for="(item, index) in identifiedPatterns" :key="`identified-${index}`"
                        class="border-b border-gray-100 pb-2 last:border-b-0 last:pb-0">
                        <div class="font-medium text-gray-900">{{ index + 1 }}. {{ item.label }}</div>
                        <div v-if="false" class="mt-2 leading-6">
                          <span class="text-gray-500">Erklärung:</span> {{ item.text }}
                        </div>
                        <div v-if="false" class="mt-1 leading-6">
                          <span class="text-gray-500">Wirkung:</span> {{ item.text2 }}
                        </div>
                      </li>
                      <li v-if="!identifiedPatterns.length" class="text-gray-400">—</li>
                    </ol>
                  </div>
                  <!-- Identifiable patterns: end -->



                  <!-- Detailed analysis: start -->
                  <div class="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
                    <div class="text-sm font-semibold text-gray-900">Detailanalyse</div>
                    <ol class="mt-4 space-y-4 text-sm text-gray-700">
                      <li v-for="(item, index) in detailedMainAnalysis" :key="`detailed-main-${index}`"
                        class="border-b border-gray-100 pb-2 last:border-b-0 last:pb-0">
                        <div class="font-semibold text-gray-900">{{ item.label }}</div>
                        <div class="mt-2 leading-6">
                          {{ item.text }}
                        </div>
                      </li>

                      <li v-for="(item, index) in detailedLanguageAnalysis" :key="`detailed-language-${index}`"
                        class="border-b border-gray-100 pb-2 last:border-b-0 last:pb-0">
                        <div class="font-semibold text-gray-900">{{ item.label }}</div>
                        <div class="mt-2 leading-6">
                          {{ item.text }}
                        </div>
                      </li>

                      <li v-if="!detailedMainAnalysis.length && !detailedLanguageAnalysis.length" class="text-gray-400">
                        —</li>
                    </ol>
                  </div>
                  <!-- Detailed analysis: end -->
                </div>
              </div>

            </div>
          </fieldset>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from '@/Pages/ControlPanel/Shared/Layout';

export default {
  metaInfo: { title: 'Copy Quick Check' },

  components: {
    Layout,
  },

  props: {
    request: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      jobStatus: this.request.status,
      jobResult: this.request.result,
      jobError: this.request.error,
      jobPromptTokens: this.request.prompt_tokens ?? null,
      jobCompletionTokens: this.request.completion_tokens ?? null,
      jobTotalTokens: this.request.total_tokens ?? null,
      jobCost: this.request.total_cost_usd ?? null,
      jobMatrixImageUrl: this.request.matrix_image_url ?? null,
      matrixImageLoading: true,
      pollTimer: null,
      inputTextExpanded: false,
      retrying: false,
      pdfDownloading: false,
      titleEditing: false,
      titleValue: this.request.title ?? '',
      titleSaving: false,
    };
  },

  mounted() {
    if (this.jobStatus !== 'completed' && this.jobStatus !== 'failed') {
      this.startPolling();
    }
  },

  methods: {
    toggleInputText() {
      this.inputTextExpanded = !this.inputTextExpanded;
    },

    startPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
      }

      this.pollTimer = setInterval(() => {
        window.axios.get(this.route('copy-quick-check.status', { uuid: this.request.uuid }))
          .then((response) => {
            this.jobStatus = response.data.status;
            this.jobResult = response.data.result;
            this.jobError = response.data.error;
            this.jobPromptTokens = response.data.prompt_tokens ?? null;
            this.jobCompletionTokens = response.data.completion_tokens ?? null;
            this.jobTotalTokens = response.data.total_tokens ?? null;
            this.jobCost = response.data.total_cost_usd ?? null;
            this.jobMatrixImageUrl = response.data.matrix_image_url ?? null;

            if (this.jobStatus === 'completed' || this.jobStatus === 'failed') {
              clearInterval(this.pollTimer);
              this.pollTimer = null;
            }
          })
          .catch(() => {
            // Keep polling in case of a transient error.
          });
      }, 1500);
    },

    retryAnalysis() {
      if (this.retrying) {
        return;
      }
      this.retrying = true;

      const tokenTag = document.querySelector('meta[name="csrf-token"]');
      const csrfToken = tokenTag ? tokenTag.getAttribute('content') : null;

      window.axios.post(this.route('copy-quick-check.retry', { uuid: this.request.uuid }), {}, {
        headers: csrfToken ? { 'X-CSRF-TOKEN': csrfToken } : {},
      })
        .then((response) => {
          this.jobStatus = response.data.status;
          this.jobError = null;
          this.jobResult = null;
          this.startPolling();
        })
        .catch(() => {
          this.jobError = 'Retry fehlgeschlagen.';
        })
        .finally(() => {
          this.retrying = false;
        });
    },

    downloadPdf() {
      if (this.pdfDownloading || this.titleSaving || !this.hasTitle) {
        return;
      }
      this.pdfDownloading = true;

      window.axios.get(this.route('copy-quick-check.pdf', { uuid: this.request.uuid }), {
        responseType: 'blob',
      })
        .then((response) => {
          const contentType = response.headers?.['content-type'] || 'application/pdf';
          const blob = new Blob([response.data], { type: contentType });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = this.getPdfFilename(response) || `copy-quick-check-${this.request.uuid}.pdf`;
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch(() => {
          // Optional: show a toast or error state.
        })
        .finally(() => {
          this.pdfDownloading = false;
        });
    },

    startEditTitle() {
      this.titleEditing = true;
      this.$nextTick(() => {
        const input = this.$el.querySelector('input[placeholder="Titel eingeben"]');
        if (input) {
          input.focus();
          input.select();
        }
      });
    },

    cancelEditTitle() {
      this.titleEditing = false;
      this.titleValue = this.request.title ?? '';
    },

    saveTitle() {
      if (!this.titleEditing) {
        return;
      }
      this.titleSaving = true;
      const tokenTag = document.querySelector('meta[name="csrf-token"]');
      const csrfToken = tokenTag ? tokenTag.getAttribute('content') : null;

      window.axios.post(this.route('copy-quick-check.title', { uuid: this.request.uuid }), {
        title: this.titleValue || null,
      }, {
        headers: csrfToken ? { 'X-CSRF-TOKEN': csrfToken } : {},
      })
        .then((response) => {
          const title = response.data?.title ?? null;
          this.request.title = title;
          this.titleValue = title ?? '';
          this.titleEditing = false;
        })
        .catch(() => {
          // Optional: show a toast or error state.
        })
        .finally(() => {
          this.titleSaving = false;
        });
    },

    getPdfFilename(response) {
      const header = response.headers?.['content-disposition'] || '';
      const match = header.match(/filename\*=UTF-8''([^;]+)|filename=\"?([^\";]+)\"?/i);
      const filename = match ? decodeURIComponent(match[1] || match[2]) : null;
      return filename || null;
    },
  },

  computed: {
    statusLabel() {
      const map = {
        queued: 'Eingabe wird analysiert',
        running: 'Abgleich mit Zentral-Datenbank',
        completed: 'Analyse abgeschlossen',
        failed: 'Fehlgeschlagen',
      };
      return map[this.jobStatus] || this.jobStatus;
    },

    formattedCost() {
      if (this.jobCost === null || this.jobCost === undefined) {
        return '—';
      }
      const cost = Number(this.jobCost);
      if (Number.isNaN(cost)) {
        return '—';
      }
      return `$${cost.toFixed(6)} USD`;
    },

    displayedInputText() {
      if (this.inputTextExpanded || !this.isInputTextTruncated) {
        return this.cleanedInputText;
      }
      return this.truncatedInputText;
    },

    inputTextWords() {
      return this.cleanedInputText.trim().split(/\s+/);
    },

    isInputTextTruncated() {
      return this.inputTextWords.length > 45;
    },

    truncatedInputText() {
      const text = this.cleanedInputText;
      if (!text) {
        return '';
      }
      const tokens = text.match(/\S+|\s+/g) || [];
      let wordCount = 0;
      let output = '';
      for (let i = 0; i < tokens.length; i += 1) {
        const token = tokens[i];
        if (/\S+/.test(token)) {
          wordCount += 1;
        }
        if (wordCount > 45) {
          break;
        }
        output += token;
      }
      return wordCount > 45 ? output.trimEnd() + '...' : output;
    },

    cleanedInputText() {
      if (!this.request.input_text) {
        return '';
      }
      return this.request.input_text
        .replace(/\r\n/g, '\n')
        .replace(/\u00A0/g, ' ')
        .replace(/^[\t ]+/gm, '')
        .replace(/\n[ \t]+/g, '\n')
        .replace(/\n{3,}/g, '\n\n')
        .trim();
    },

    statusBadgeClass() {
      if (this.jobStatus === 'completed') {
        return 'bg-green-100 text-green-800';
      }
      if (this.jobStatus === 'failed') {
        return 'bg-red-100 text-red-800';
      }
      return 'bg-yellow-100 text-yellow-800';
    },

    displayTitle() {
      return this.titleValue?.trim() ? this.titleValue : 'Klicken, um Titel hinzuzufügen';
    },

    isTitlePlaceholder() {
      return !this.titleValue?.trim();
    },

    titleButtonClass() {
      if (this.isTitlePlaceholder) {
        return 'text-xs italic text-gray-500 hover:text-gray-600';
      }
      return 'text-sm text-gray-700 hover:text-gray-900';
    },

    hasTitle() {
      return !!(this.request.title && this.request.title.trim());
    },

    pdfIconClass() {
      const isDisabled = !this.hasTitle || this.pdfDownloading;
      return [
        'hover:text-markencode-blue',
        isDisabled ? 'opacity-50 pointer-events-none' : 'cursor-pointer',
      ];
    },

    resultByType() {
      const items = Array.isArray(this.jobResult) ? this.jobResult : [];
      return items.reduce((acc, item) => {
        if (!item || !item.type) {
          return acc;
        }
        if (!acc[item.type]) {
          acc[item.type] = [];
        }
        acc[item.type].push(item);
        return acc;
      }, {});
    },

    matrixImageUrl() {
      return this.jobMatrixImageUrl || this.request.matrix_image_url || null;
    },

    centralTheme() {
      const items = this.resultByType.central_theme || [];
      return items.length ? items[0] : { label: null, text: null };
    },

    uniquenessText() {
      const items = this.resultByType.uniqueness || [];
      return items.length ? items[0].text : null;
    },

    languageStyle() {
      const items = this.resultByType.language_style || [];
      return items.length ? items[0] : { label: null, text: null };
    },

    characterizationAdjectives() {
      return this.resultByType.characterization_adjective || [];
    },

    styleAdjectives() {
      return this.resultByType.style_adjective || [];
    },

    identifiedPatterns() {
      return this.resultByType.identified_pattern_note || [];
    },

    detailedMainAnalysis() {
      return this.resultByType.detailed_main_analysis || [];
    },

    detailedLanguageAnalysis() {
      return this.resultByType.detailed_language_analysis || [];
    },
  },

  watch: {
    matrixImageUrl(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.matrixImageLoading = true;
      }
    },
  },

  beforeDestroy() {
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
    }
  },
};
</script>
